import React, { Suspense } from 'react';
import { useRoutes, Navigate } from 'react-router-dom';

// components
import Root from './Root';

// lazy load components
const Home = React.lazy(() => import('pages/landings/Home/Home'));
const Careers = React.lazy(() => import('pages/landings/Careers/Careers'));
const JobDetail = React.lazy(() => import('pages/landings/Careers/JobDetail'));
const PrivacyPolicyRedirect = React.lazy(() => import('pages/PrivacyPolicyRedirect'));

const loading = () => <div className=""></div>;

type LoadComponentProps = {
    component: React.LazyExoticComponent<() => JSX.Element>;
};

const LoadComponent = ({ component: Component }: LoadComponentProps) => (
    <Suspense fallback={loading()}>
        <Component />
    </Suspense>
);

const AllRoutes = () => {
    return useRoutes([
        {
            // root route
            path: '/',
            element: <Root />,
        },
        {
            // public routes
            path: '/',
            children: [
                {
                    path: 'home',
                    element: <LoadComponent component={Home} />,
                },
                {
                    // Medtrade 2026 ended Mar 2-4. Old links 301 to home.
                    path: 'medtrade-2026',
                    element: <Navigate to="/" replace />,
                },
                {
                    path: 'medtrade-2026/*',
                    element: <Navigate to="/" replace />,
                },
                {
                    path: 'careers',
                    element: <LoadComponent component={Careers} />,
                },
                {
                    path: 'careers/:slug',
                    element: <LoadComponent component={JobDetail} />,
                },
                {
                    path: 'privacy-policy',
                    element: <LoadComponent component={PrivacyPolicyRedirect} />,
                },
            ],
        },
    ]);
};

export default AllRoutes;